import { render, staticRenderFns } from "./DocumentLimitLoan.vue?vue&type=template&id=124288bd&scoped=true&"
import script from "./DocumentLimitLoan.vue?vue&type=script&lang=js&"
export * from "./DocumentLimitLoan.vue?vue&type=script&lang=js&"
import style0 from "./DocumentLimitLoan.vue?vue&type=style&index=0&id=124288bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124288bd",
  null
  
)

export default component.exports